import React from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import Header from '../Components/Dashboard/Header/Header';
import Sidebar from '../Components/Dashboard/Sidebar/Sidebar';
import Reporting from '../Components/Dashboard/Reporting/Reporting';

import { useAppContext } from '../Context/App/Provider';
import { useEventContext } from '../Context/Event/Provider';

export default function ReportingPage() {
  // const [{ user }] = useAppContext();

  return (
    <>
      <Header />
      <div className="body">
        <Switch>
          <Route exact path='/reporting'>

            <Sidebar />
            <Reporting />

          </Route>

          {/* {user.roleId !== roles.user && (
            <Route exact path='/reporting/settings'>
              <div className="reporting__settings">
                <ReportingSettings />
              </div>
            </Route>
          )}
          {user.roleId !== roles.user && (
            <Route exact path='/reporting/settings/scenario/:id'>
              <div className="reporting__settings">
                <EditScenario />
              </div>
            </Route>
          )} */}

          <Route render={() => <Redirect to='/reporting' />} />
        </Switch>
      </div>

    </>
  );
}
